import { render, staticRenderFns } from "./parcel-forum-2026-banner.vue?vue&type=template&id=d1482940&scoped=true&"
import script from "./parcel-forum-2026-banner.vue?vue&type=script&lang=js&"
export * from "./parcel-forum-2026-banner.vue?vue&type=script&lang=js&"
import style0 from "./parcel-forum-2026-banner.vue?vue&type=style&index=0&id=d1482940&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1482940",
  null
  
)

export default component.exports